import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { getServices } from "@/lib/api";
import { Reveal } from "@/lib/motion";
import { PageHero } from "@/components/ui-kit";
import { useSeo } from "@/lib/useSeo";

export default function Services() {
  useSeo({ title: "Services", description: "Full home interiors, modular kitchens, wardrobes, false ceilings, renovation and commercial interiors in Kolkata." });
  const { data: services = [] } = useQuery({ queryKey: ["services"], queryFn: getServices });

  return (
    <div data-testid="services-page">
      <PageHero overline="What We Do" title="Turnkey services," italic="one studio."
        sub="From a single room to a complete home or workspace — designed, engineered and executed with boutique care." />

      <section className="mx-auto max-w-[1400px] px-6 md:px-10 pb-24 md:pb-32">
        <div className="grid md:grid-cols-2 gap-8">
          {services.map((s, i) => (
            <Reveal key={s.slug} delay={(i % 2) * 0.1}>
              <Link to={`/services/${s.slug}`} data-testid={`services-item-${s.slug}`}
                className="group grid sm:grid-cols-2 border border-gold/20 rounded-md overflow-hidden bg-ivory hover:-translate-y-1 transition-transform duration-500">
                <div className="overflow-hidden h-56 sm:h-full">
                  <img src={s.hero_image} alt={s.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" loading="lazy" />
                </div>
                <div className="p-8 flex flex-col justify-center">
                  <span className="font-display text-4xl text-gold/40">{String(i + 1).padStart(2, "0")}</span>
                  <h3 className="font-display text-3xl mt-1">{s.title}</h3>
                  <p className="text-ink/65 text-lg mt-3 leading-relaxed">{s.tagline}</p>
                  <span className="mt-5 text-sm uppercase tracking-[0.2em] font-bold text-bronze">Explore →</span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
